import * as React from 'react';

import {Body} from 'shells/typography/body';

import {DefaultReportsGrid} from './default-reports-grid';
import {getReportGroupingName} from './reports-list';
import type {DefaultReport, DefaultReportGrouping} from './types';

type Props = {
    grouping: DefaultReportGrouping;
    reports: DefaultReport[];
};

export function DefaultReportsSubsection(props: Props) {
    const groupingName = getReportGroupingName(props.grouping);

    const illustrationPosition = props.grouping === 'effort' ? 'right' : 'left';

    return (
        <div className='flex flex-dir-col gap-12'>
            <Body isBold={true} color='dark' size='large' useDoyle={true}>
                {groupingName}
            </Body>
            <DefaultReportsGrid
                reports={props.reports}
                illustrationPosition={illustrationPosition}
            />
        </div>
    );
}
